import styled from "styled-components";

export const ResetPassWrapper = styled.div``